// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/coffee-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Reenie+Beanie&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cedarville+Cursive&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Tangerine&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Imports
--------------------------------------------------------------*/

/*--------------------------------------------------------------
# Global
--------------------------------------------------------------*/

html, body {
  height: 100%;
  width: 100%;
  font-family: 'Montserrat', sans-serif;
  color: #683E00;
  font-size: 16px;
}

body {
  background-image: linear-gradient(#E6F1E1,#A4C5F8);
  margin: 0; 
  background-repeat: no-repeat;
  background-attachment: fixed;
}

img {
  max-width: 100%;
}

.padding {
  padding-bottom: 5%;
}

.keyword-dark {
  color: #3B2A1C;
}

.keyword-light {
  color: #4A3C2B;
}

/*--------------------------------------------------------------
# Button Styles
--------------------------------------------------------------*/

.btn {
  transition: 0.5s;
}

.btn-outline-dark {
  background-color: transparent;
  color: #FCEAFF;
  border: 2px solid #00C9A9;
}

.btn-outline-dark:hover {
  background-color: #00C9A9;
  color: #1E1E1E;
  border: 2px solid #00C9A9;
}

.btn-outline-light {
  background-color: transparent;
  color: #683E00;
  border: 2px solid #683E00;
}

.btn-outline-light:hover {
  background-color: #683E00;
  color: #DDF2FF;
  border: 2px solid #683E00;
}

.btn-dark {
  background-color: #2f145e;
  /* border: 2px solid #1E1E1E; */
  color: #FCEAFF;
}

.btn-dark:hover {
  background-color: #1f0d3e;
  border-color:  #1f0d3e;
}

.btn-light {
  background-color: #DDF2FF;
  /* border: 2px solid #DDF2FF; */
  color: #683E00;
}

.btn-light:hover {
  background-color: #bcccd6;
  border-color: #bcccd6;
}

/* Mode button */
.btn-mode {
  border: none;
  font-size: 1.5rem;
  transition: transform .7s ease-in-out;
}

.btn-mode:active {
  transform: rotate(360deg);
}

.btn-mode-dark {
  color: #00C9A9;
}

.btn-mode-dark:hover {
  color: #b8eadf;
}

.btn-mode-light {
  color: #897456;
}

.btn-mode-light:hover {
  color: #b69972;
}

/*--------------------------------------------------------------
# Section Break Styles
--------------------------------------------------------------*/

.section-break-title {
  padding-bottom: 40px;
}

.section-break-title-dark h2,
.section-break-title-light h2 {
  font-weight: 500;
  padding: 0;
  line-height: 1px;
  margin: 0 0 5px;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
}

.section-break-title-dark h2 {
  font-size: 14px;
  color: #FCEAFF;
}

.section-break-title-dark h2::after {
  content: "";
  width: 120px;
  height: 1px;
  display: inline-block;
  background: #00C9A9;
  margin: 4px 10px;
}

.section-break-title-light h2 {
  font-size: 14px;
  color: #683E00;
}

.section-break-title-light h2::after {
  content: "";
  width: 120px;
  height: 1px;
  display: inline-block;
  background: #897456;
  margin: 4px 10px;
}

/*--------------------------------------------------------------
# Section Styles
--------------------------------------------------------------*/

.container-fluid.section-dark {
  /* background-image: linear-gradient(#6F4F28, #1E1E1E); */
  padding: 4% 0;
  color: #1E1E1E;
}

.container-fluid.section-light {
  /* background-image: linear-gradient(#A4C5F8,#6D8FBF); */
  /* background-image: linear-gradient(#E6F1E1,#A4C5F8); */
  padding: 4% 0;
  color: #F9F9F9;
}

/*--------------------------------------------------------------
# Chrome Autocomplete Styles
--------------------------------------------------------------*/

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-text-fill-color: white;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

/*--------------------------------------------------------------
# Navbar
--------------------------------------------------------------*/

.navbar {
  transition: all 0.3s ease-in-out;
}

.navbar-dark .navbar-nav .nav-link {
  color: #FCEFFE;
}

.navbar-light .navbar-nav .nav-item .active {
  color: #d88200;
}

.navbar-light .navbar-nav .nav-link {
  color: #683E00;
}

.navbar-light .navbar-nav .nav-link:hover {
  color: #ac6700;
}

.navbar.scrolled-down {
  transform: translateY(-100%);
}

/*--------------------------------------------------------------
# Banner
--------------------------------------------------------------*/
.banner {
  left: 0%;
  position:absolute;
  height: 100%;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.banner img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

img#cup-outer {
  z-index: 5;
}

img#cup-inner {
  z-index: 2;
}


img#coffee-beans {
  z-index: 3;
}

img#splash {
  z-index: 4;
}

img#shadow {
  z-index: 2;
}

/*--------------------------------------------------------------
# Jumbotron
--------------------------------------------------------------*/
.jumbotron p {
  font-size: 1.5em;
}

.cta {
  background: linear-gradient(rgba(2, 2, 2, 0.5), rgba(0, 0, 0, 0.5)), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) fixed center center;
  background-size: cover;
  padding: 60px 0;
}

.cta h3 {
  color: #DDF2FF;
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.cta p {
  font-size: 1.1rem;
  color: #DDF2FF;
}

/*--------------------------------------------------------------
# hero
--------------------------------------------------------------*/
.hero h1 {
  margin-top: 1rem;
  font-size: 7rem;
}

.hero-dark p {
  color: #FCEAFF;
}

.hero-light p {
  color: #683E00;
}

.hero h1:after {
  content: ".";
}

.hero-dark h1 {
  color: #FCEAFF;
}

.hero-dark h1:after {
  color: #00C9A9;
}

.hero-light h1 {
  color: #683E00;
}

.hero-light h1:after {
  color: #897456;
}

.hero{
  margin-bottom: 11em;
}

/*--------------------------------------------------------------
# Links & Badges
--------------------------------------------------------------*/
a.a-dark {
  color: #00C9A9;
  text-decoration: none;
}

a.a-light {
  color: #897456;
  text-decoration: none;
}

a.a-dark:hover {
  color: #009d83;
}

a.a-light:hover {
  color: #5b79a2;
}

.badge.bg-dark {
  background-color: #897456 !important;
}

.badge.bg-light {
  color: #1E1E1E !important;
}

/*--------------------------------------------------------------
# About
--------------------------------------------------------------*/
.about{
  background-color: transparent;
  border-radius: 30px;
  padding:3%;
  padding-left:5%;
  padding-right:5%;
  margin-bottom:7%;
  /* box-shadow: 0px 50px 50px -40px #000000; */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
  margin-top:2%;
  transition: 0.3s ease-in-out;
}

.about:hover{
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3), 0 12px 40px rgba(0, 0, 0, 0.25);
}

.about.about-dark{
  border:5px solid #9d9d9d;
}

.about.about-dark:hover{
  border:5px solid #00C9A9;
}

.about.about-light{
  border:5px solid #DDF2FF;
}

.about.about-light:hover{
  border:5px solid #bdb4a8;
}

.about .about-icon{
  padding:0.9%;
  font-size: 1.5rem;
}

.about .about-icon-dark{
  background-color:#00C9A9;
  color:#2D1458;
}

.about .about-icon-light{
  background-color:#683E00;
  color:#DDF2FF;
}

.about h1{
  font-size: 6rem;
}

.about h1:nth-child(1){
  margin-left:-2rem;
}

.about h1:nth-child(2){
  margin-left:-0.7rem;
}

.about.about-dark h1{
  color:#2D1458;
}

.about.about-light h1{
  color:#683E00;
}

.about.about-dark h1:nth-child(2):after{
  content: '.';
  color:#00C9A9;
}

.about.about-light h1:nth-child(2):after{
  content: '.';
  color:#897456;
}

.about .about-para{
  font-size:0.8rem;
  text-align: end;
}

.about .about-para-dark{
  color:#bdbcbc;
}

.about .about-para-light{
  color:#747474;
}

/*--------------------------------------------------------------
# Contact
--------------------------------------------------------------*/
.card.scroll-background {
  background: #FFFFFF; /* Base color of the scroll */
  background-image: 
  linear-gradient(135deg, #FFFFFF 0%, #F5F5F5 50%, #FFFFFF 100%),
  linear-gradient(to right, #FFFFFF 0%, #F5F5F5 50%, #FFFFFF 100%);
  background-blend-mode: multiply;
  border-radius: 4px;
  /* box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1),
              inset 0 -1px 3px rgba(0, 0, 0, 0.05); */
  position: relative;
  overflow: hidden;
  padding: 2rem; /* Adjust based on how much space you want inside the scroll */
  height: 100%; /* Adjust based on the size of your scroll */
  width: 100%; /* Adjust based on the size of your scroll */
  border:none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
}

.card.scroll-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 20% 20%, rgba(179, 155, 155, 0.1), transparent);
  pointer-events: none;
}

.card.scroll-background::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px; /* Adjust based on the size of the curl effect */
  background: radial-gradient(circle at 50% 50%, rgba(86, 85, 85, 0.2), transparent);
  border-radius: 50% 50% 0 0;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}

.card .letter{
    /* font-family: 'Cedarville Cursive', cursive; */
    font-family: 'Tangerine', cursive;;
    font-size:2.2rem;
    color:#683E00;
}

.container-fluid.contact-dark label{
    color:#FCEAFF;
}

.container-fluid.contact input,.container-fluid.contact textarea{
    background-color: transparent;
    border:none;
    border-radius: 1px;
}

.container-fluid.contact select{
    background-color: transparent;
    border:none;
    border-radius: 1px;
}

.container-fluid.contact-dark input,.container-fluid.contact-dark textarea{
  background-color: transparent;
    color:#FCEAFF;
    border-bottom:1px solid #FCEAFF;
}

.container-fluid.contact-dark select{
    color:#FCEAFF;
    border-top:1px solid #FCEAFF;
}

.container-fluid.contact-dark option{
    color:#1E1E1E;
}

.container-fluid.contact-light label{
    color:#683E00;
}

.container-fluid.contact-light input,.container-fluid.contact-light textarea{
    color:#683E00;
    border-bottom:1px solid #683E00;
}

.container-fluid.contact-light select{
    color:#683E00;
    border-top:1px solid #683E00;
}

.container-fluid.contact-light option{
    color:#683E00;
}

.container-fluid.contact .card{
    padding-top:1rem;
    margin-right:3rem;
    position:relative;
    top:-10%;
    height: 120%;
}

.contact .card-subtitle{
    font-size: 1.8rem;
    float:right;
}

/*--------------------------------------------------------------
# Menu 
--------------------------------------------------------------*/

.container.menu-list select{
  background-color: transparent;
  border:none;
  border-radius: 1px;
}

/* .container.menu-list-dark select{
  color:#FCEAFF;
  border-top:1px solid #FCEAFF;
} */

/* .container.menu-list-light select{
  color:#683E00;
  border-top:1px solid #683E00;
} */

.container.menu-list input{
  background-color: transparent;
  border:none;
  border-radius: 1px;
}

.container.menu-list-dark input,.container.menu-list-dark textarea{
background-color: transparent;
  color:#FCEAFF;
  border-bottom:1px solid #FCEAFF;
}

.container.menu-list-light input,.container.menu-list-light textarea{
  color:#683E00;
  border-bottom:1px solid #683E00;
}

.item-card.card{
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
}

.item-card-light.card{
  background-color: #DDF2FF;
}

.item-card-dark.card{
  background-color:#2c2c2c;
}

.item-card .card-img-container {
  position: relative;
}

.item-card .card-price {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 5px 10px;
  border-radius: 5px;
  z-index: 2;
}

.item-card-light .card-price{
  color: #DDF2FF;
}

.item-card-dark .card-price{
  color:#00C9A9;
}

.item-card .card-img-top {
  width: 100%;
  height: auto;
  display: block;
}

.item-card .card-body {
  position: relative;
  z-index: 1;
}

.item-card .card-text {
  height: 4.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  overflow-wrap: break-word;
}

.item-card small{
  text-decoration: line-through;
  color: gray;
}

small.marked-price{
  text-decoration: line-through;
  color: gray;
}

.item-img{
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
}

/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
.footer{
  font-size:6vh;
  font-family: 'Montserrat', sans-serif;
  position:absolute;
  white-space: nowrap;
  z-index: 2;
  padding-top: 4%;
  padding-bottom: 4%;
}

.container-fluid.footer-dark {
  /* background-image: linear-gradient(#6F4F28, #1E1E1E); */
  color: #1E1E1E;
}

.container-fluid.footer-light {
  /* background-image: linear-gradient(#A4C5F8,#6D8FBF); */
  color: #F9F9F9;
}

.footer .row.padding-top{
  padding-top:7rem;
}

.footer .row.padding-bottom{
  padding-bottom:20rem;
}

.footer small{
  font-size:10px;
  color:rgb(170, 169, 169);
  margin-bottom: 10px;
}

.footer-light small{
  color:#e7e7e7;
}

.footer a{
  font-size:1.5rem;
}

.footer-light a:hover{
  border-color:#683E00;
}

.footer-dark a:hover{
  border-color:#00C9A9;
}

.footer-light h1{
  color:#683E00;
}

.footer-dark h1:after{
  content:".";
  color:#00C9A9;
}

.footer-light h1:after{
  content:".";
  color:#897456;
}

/*--------------------------------------------------------------
# Animated Button
--------------------------------------------------------------*/

.flow-chart-light h1{
  color:#683E00;
}

.flow-chart-dark h1:after{
  content:"?";
  color:#00C9A9;
}

.flow-chart-light h1:after{
  content:"?";
  color:#897456;
}


/*--------------------------------------------------------------
# Animated Button
--------------------------------------------------------------*/
a.anime-button.btn-light{
  color:#634d1a;
  background-color: #DDF2FF;
}

a.anime-button.btn-light:hover{
  background-color: #b3dffb;
}

a.anime-button.btn-dark{
  background-color:#00C9A9;
  color: #2f145e;
}

a.anime-button.btn-dark:hover {
  background-color: #00977e;
  color:#e7e7e7;
}

a.anime-button{
  position: absolute;
  padding:1em;
  letter-spacing:2px;
  text-transform:uppercase;
  text-decoration:none;
  box-shadow:0 5px 10px rgba(0,0,0,.5);
  overflow:hidden;
  border:none;
}

a.anime-button:before{
content: '';
position: absolute;
top: 2px;
left: 2px;
bottom: 2px;
width: 50%;
background: rgba(255,255,255,0.05);
}

a.anime-button-light span:nth-child(1){
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, #d2b48c, #c8a475, #b89463, #a5834e, #8f7138, #7a6025, #634d1a);
  animation: animate1 2s linear infinite;
}

a.anime-button-dark span:nth-child(1){
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;  
  background: linear-gradient(to left, #00C9A9, #00B0A4, #009f95, #008f86, #007d78, #006d6a, #005d5b);
  animation: animate1 2s linear infinite;
}

@keyframes animate1{
   0%
   {
     transform:translateX(-100%);
   
   }
   100%
   {
     transform:translateX(100%);
   
   }
}

/* a.anime-button-light span:nth-child(2){
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(to bottom, #00FFFF, #00D4FF, #00AAFF, #0088FF, #0066FF, #004CFF, #002EFF);
  animation: animate2 2s linear infinite;
  animation-delay: 1s;
}

@keyframes animate2 {
   0%
   {
     transform:translateY(-100%);
   
   }
   100%
   {
     transform:translateY(100%);
   
   }
} */

a.anime-button-light span:nth-child(3){
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to left, #d2b48c, #c8a475, #b89463, #a5834e, #8f7138, #7a6025, #634d1a);
  animation: animate3 2s linear infinite;
}

a.anime-button-dark span:nth-child(3){
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to left, #00C9A9, #00B0A4, #009f95, #008f86, #007d78, #006d6a, #005d5b);
  animation: animate3 2s linear infinite;
}

@keyframes animate3
  {
   0%
   {
     transform:translateX(100%);
   
   }
   100%
   {
     transform:translateX(-100%);
   
   }
}

/* a.anime-button-light span:nth-child(4){
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(to top, #00FFFF, #00D4FF, #00AAFF, #0088FF, #0066FF, #004CFF, #002EFF);
  animation: animate4 2s linear infinite;
  animation-delay: 1s;
}

@keyframes animate4 {
   0%
   {
     transform:translateY(100%);
   
   }
   100%
   {
     transform:translateY(-100%);
   
   }
} */


/*--------------------------------------------------------------
# Customer Details
--------------------------------------------------------------*/

.customer{
  font-size: 6em;
}

.bronze-customer {
  background: linear-gradient(to right, #F2C185, #8C6046, #BF8F65, #D9A577,  #593528);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  display: inline-block;
}

.silver-customer {
  background: linear-gradient(to right, #DCEAF2, #3B403F, #C5D1D9 , #79878C,  #0C0D0C);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  display: inline-block;
}

.gold-customer {
  background: linear-gradient(to right, #F2CF66, #A65814, #F2BF5E, #D99036, #59331D);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  display: inline-block;
}

.platinum-customer {
  background: linear-gradient(to right, #727A8C, #434D59, #C7CFD9, #366873, #143B40);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  display: inline-block;
}

.bizarre-coin-light {
  margin-top:0.2em;
  font-size: 12rem;
  filter: drop-shadow(5px 1px 4px rgba(0, 0, 0, 0.9));
  color:#A65814;
}

.bizarre-coin-dark {
  margin-top:0.2em;
  font-size: 12rem;
  filter: drop-shadow(5px 1px 4px rgba(0, 0, 0, 0.9));
  color:#F2BF5E;
}

.coin-currency{
  position: relative;
  top: -2px;
}

.fa-bitcoin {
  background: linear-gradient(to right, #F2CF66, #A65814, #F2BF5E, #D99036);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  margin-top:0.2em;
  font-size: 12rem;
  filter: drop-shadow(5px 1px 4px rgba(44, 44, 44, 0.9));
}

.verified-icon{
  font-size: 3rem;
  position: relative;
  top: -1em;
  left: -0.2em;
}

.verified-icon-light{
  color:#A65814;
}

.verified-icon-dark{
  color:#00C9A9;
}

/*--------------------------------------------------------------
# Not Found
--------------------------------------------------------------*/
.not-found{
  padding: 1.7em;
  font-size: 6em;
}

.not-found-light {
  background: linear-gradient(to right, #F2C185, #8C6046, #BF8F65, #D9A577,  #593528);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  display: inline-block;
}

.not-found-dark {
  background: linear-gradient(to right, #00C9A9, #007d78, #00B0A4, #008f86, #005d5b);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  display: inline-block;
}


/*--------------------------------------------------------------
# Media Queries Small Phones
--------------------------------------------------------------*/

@media only screen and (max-width: 600px) {

  .btn{
    font-size: 1em;
  }
  
  .section-break-title {
    padding-bottom: 2%;
    margin-left: 5%;
    padding-top:2%;
  }

  .jumbotron p{
    font-size: 1.2em;
  }

  .cta h3 {
    font-size: 1em;
  }
  
  .cta p {
    font-size: 0.7rem;
  }

  .hero h1{
    margin-top:2%;
    font-size: 4.5rem;
  }

  .hero p {
    margin-top:2rem;
    font-size: 1.2rem;
  }

  .customer{
    font-size: 3em;
  }

  .not-found{
    padding: 1.2em;
    font-size: 3em;
    text-align: center;
  }

  .hero .float-end{
    float:none!important;
  }

  .footer .row.padding-top{
    padding-top:14rem;
  }
  
  .footer .row.padding-bottom{
    padding-bottom:21rem;
  }

  .card .letter{
    font-size:1.5rem;
  }

  .contact .card-subtitle{
    font-size: 1.2rem;
  }

  .about{
    padding:2rem;
    margin-bottom: 5rem;
  }

  .about h1{
  font-size: 4rem;
  }

  .about .about-para{
    font-size:0.6rem;
    text-align: center;
  }

  a.a-dark{
    font-size:0.6rem
  }

  a.a-light{
    font-size:0.7rem
  }

  .swiper-slide{
    left: -6rem;
  }
  
  .verified-icon{
    font-size: 1.8rem;
    position: relative;
    top: -0.7em;
    left: -0.2em;
  }
}

/*--------------------------------------------------------------
# Media Queries iPhone
--------------------------------------------------------------*/
@media (min-width: 400px) and (max-width: 600px) {

  .menu-container{
    margin-left:20px;
  }

  .hero{
    margin-bottom: 16em;
  }

}


/*--------------------------------------------------------------
# Media Queries Landscape Tablets
--------------------------------------------------------------*/
@media only screen and (min-width: 768px) {

  .hero h1{
    margin-top:5%;
    font-size: 4rem;
  }

  .customer{
    font-size: 4em;
  }

  .not-found{
    padding: 0.9em;
    font-size: 4em;
  }

  .footer .row.padding-top{
    padding-top:10rem;
  }
  
  .footer .row.padding-bottom{
    padding-bottom:21rem;
  }

  .card .letter{
    font-size:1.8rem;
  }

  .contact .card-subtitle{
    font-size: 1.5rem;
  }
}

/*--------------------------------------------------------------
# Media Queries Landscape Tablets
--------------------------------------------------------------*/
@media only screen and (min-width: 992px) {

  .hero h1{
    margin-top:0%;
    font-size: 6.6rem;
  }  

  .customer{
    font-size: 5em;
  }

  .not-found{
    padding: 1em;
    font-size: 6em;
  }

  .footer .row.padding-top{
    padding-top:8.8rem;
  }
  
  .footer .row.padding-bottom{
    padding-bottom:20rem;
  }

  .card .letter{
    font-size:2.1rem;
  }

  .contact .card-subtitle{
    font-size: 1.8rem;
  }
}


`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;+DAE+D;;AAQ/D;;+DAE+D;;AAE/D;EACE,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,SAAS;EACT,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+DAE+D;;AAE/D;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+DAE+D;;AAE/D;EACE,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;+DAE+D;;AAE/D;EACE,yDAAyD;EACzD,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,wDAAwD;EACxD,wDAAwD;EACxD,aAAa;EACb,cAAc;AAChB;;AAEA;;+DAE+D;;AAE/D;;;EAGE,8BAA8B;EAC9B,oDAAoD;EACpD,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;;+DAE+D;;AAE/D;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;+DAE+D;AAC/D;EACE,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;AAClB;;AAEA;EACE,gIAAuH;EACvH,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;+DAE+D;AAC/D;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+DAE+D;AAC/D;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;+DAE+D;AAC/D;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,wEAAwE;EACxE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;+DAE+D;AAC/D;EACE,mBAAmB,EAAE,6BAA6B;EAClD;;kEAEgE;EAChE,+BAA+B;EAC/B,kBAAkB;EAClB;qDACmD;EACnD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa,EAAE,8DAA8D;EAC7E,YAAY,EAAE,4CAA4C;EAC1D,WAAW,EAAE,4CAA4C;EACzD,WAAW;EACX,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY,EAAE,gDAAgD;EAC9D,kFAAkF;EAClF,0BAA0B;EAC1B,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;IACI,gDAAgD;IAChD,iCAAiC;IACjC,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;AACtB;;AAEA;EACE,6BAA6B;IAC3B,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;;+DAE+D;;AAE/D;EACE,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;;;GAGG;;AAEH;EACE,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;AACpB;;AAEA;AACA,6BAA6B;EAC3B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;EACb,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,cAAc;AAChB;;AAEA;EACE,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;;+DAE+D;;AAE/D;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;;AAGA;;+DAE+D;AAC/D;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,oCAAoC;EACpC,eAAe;EACf,WAAW;AACb;;AAEA;AACA,WAAW;AACX,kBAAkB;AAClB,QAAQ;AACR,SAAS;AACT,WAAW;AACX,UAAU;AACV,kCAAkC;AAClC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oGAAoG;EACpG,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,mGAAmG;EACnG,sCAAsC;AACxC;;AAEA;GACG;;KAEE,2BAA2B;;GAE7B;GACA;;KAEE,0BAA0B;;GAE5B;AACH;;AAEA;;;;;;;;;;;;;;;;;;;;;;GAsBG;;AAEH;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mGAAmG;EACnG,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mGAAmG;EACnG,sCAAsC;AACxC;;AAEA;;GAEG;;KAEE,0BAA0B;;GAE5B;GACA;;KAEE,2BAA2B;;GAE7B;AACH;;AAEA;;;;;;;;;;;;;;;;;;;;;;GAsBG;;;AAGH;;+DAE+D;;AAE/D;EACE,cAAc;AAChB;;AAEA;EACE,mFAAmF;EACnF,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oFAAoF;EACpF,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kFAAkF;EAClF,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kFAAkF;EAClF,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,yEAAyE;EACzE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;+DAE+D;AAC/D;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mFAAmF;EACnF,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kFAAkF;EAClF,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA;;+DAE+D;;AAE/D;;EAEE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;EACA,eAAe;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;+DAE+D;AAC/D;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;AAEF;;;AAGA;;+DAE+D;AAC/D;;EAEE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;+DAE+D;AAC/D;;EAEE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/*--------------------------------------------------------------\n# Imports\n--------------------------------------------------------------*/\n\n@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,700');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Reenie+Beanie&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Cedarville+Cursive&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Tangerine&display=swap');\n\n/*--------------------------------------------------------------\n# Global\n--------------------------------------------------------------*/\n\nhtml, body {\n  height: 100%;\n  width: 100%;\n  font-family: 'Montserrat', sans-serif;\n  color: #683E00;\n  font-size: 16px;\n}\n\nbody {\n  background-image: linear-gradient(#E6F1E1,#A4C5F8);\n  margin: 0; \n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\nimg {\n  max-width: 100%;\n}\n\n.padding {\n  padding-bottom: 5%;\n}\n\n.keyword-dark {\n  color: #3B2A1C;\n}\n\n.keyword-light {\n  color: #4A3C2B;\n}\n\n/*--------------------------------------------------------------\n# Button Styles\n--------------------------------------------------------------*/\n\n.btn {\n  transition: 0.5s;\n}\n\n.btn-outline-dark {\n  background-color: transparent;\n  color: #FCEAFF;\n  border: 2px solid #00C9A9;\n}\n\n.btn-outline-dark:hover {\n  background-color: #00C9A9;\n  color: #1E1E1E;\n  border: 2px solid #00C9A9;\n}\n\n.btn-outline-light {\n  background-color: transparent;\n  color: #683E00;\n  border: 2px solid #683E00;\n}\n\n.btn-outline-light:hover {\n  background-color: #683E00;\n  color: #DDF2FF;\n  border: 2px solid #683E00;\n}\n\n.btn-dark {\n  background-color: #2f145e;\n  /* border: 2px solid #1E1E1E; */\n  color: #FCEAFF;\n}\n\n.btn-dark:hover {\n  background-color: #1f0d3e;\n  border-color:  #1f0d3e;\n}\n\n.btn-light {\n  background-color: #DDF2FF;\n  /* border: 2px solid #DDF2FF; */\n  color: #683E00;\n}\n\n.btn-light:hover {\n  background-color: #bcccd6;\n  border-color: #bcccd6;\n}\n\n/* Mode button */\n.btn-mode {\n  border: none;\n  font-size: 1.5rem;\n  transition: transform .7s ease-in-out;\n}\n\n.btn-mode:active {\n  transform: rotate(360deg);\n}\n\n.btn-mode-dark {\n  color: #00C9A9;\n}\n\n.btn-mode-dark:hover {\n  color: #b8eadf;\n}\n\n.btn-mode-light {\n  color: #897456;\n}\n\n.btn-mode-light:hover {\n  color: #b69972;\n}\n\n/*--------------------------------------------------------------\n# Section Break Styles\n--------------------------------------------------------------*/\n\n.section-break-title {\n  padding-bottom: 40px;\n}\n\n.section-break-title-dark h2,\n.section-break-title-light h2 {\n  font-weight: 500;\n  padding: 0;\n  line-height: 1px;\n  margin: 0 0 5px;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.section-break-title-dark h2 {\n  font-size: 14px;\n  color: #FCEAFF;\n}\n\n.section-break-title-dark h2::after {\n  content: \"\";\n  width: 120px;\n  height: 1px;\n  display: inline-block;\n  background: #00C9A9;\n  margin: 4px 10px;\n}\n\n.section-break-title-light h2 {\n  font-size: 14px;\n  color: #683E00;\n}\n\n.section-break-title-light h2::after {\n  content: \"\";\n  width: 120px;\n  height: 1px;\n  display: inline-block;\n  background: #897456;\n  margin: 4px 10px;\n}\n\n/*--------------------------------------------------------------\n# Section Styles\n--------------------------------------------------------------*/\n\n.container-fluid.section-dark {\n  /* background-image: linear-gradient(#6F4F28, #1E1E1E); */\n  padding: 4% 0;\n  color: #1E1E1E;\n}\n\n.container-fluid.section-light {\n  /* background-image: linear-gradient(#A4C5F8,#6D8FBF); */\n  /* background-image: linear-gradient(#E6F1E1,#A4C5F8); */\n  padding: 4% 0;\n  color: #F9F9F9;\n}\n\n/*--------------------------------------------------------------\n# Chrome Autocomplete Styles\n--------------------------------------------------------------*/\n\ninput:-webkit-autofill,\ntextarea:-webkit-autofill,\nselect:-webkit-autofill {\n  -webkit-text-fill-color: white;\n  -webkit-box-shadow: 0 0 0px 1000px transparent inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/*--------------------------------------------------------------\n# Navbar\n--------------------------------------------------------------*/\n\n.navbar {\n  transition: all 0.3s ease-in-out;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n  color: #FCEFFE;\n}\n\n.navbar-light .navbar-nav .nav-item .active {\n  color: #d88200;\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: #683E00;\n}\n\n.navbar-light .navbar-nav .nav-link:hover {\n  color: #ac6700;\n}\n\n.navbar.scrolled-down {\n  transform: translateY(-100%);\n}\n\n/*--------------------------------------------------------------\n# Banner\n--------------------------------------------------------------*/\n.banner {\n  left: 0%;\n  position:absolute;\n  height: 100%;\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.banner img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 1;\n}\n\nimg#cup-outer {\n  z-index: 5;\n}\n\nimg#cup-inner {\n  z-index: 2;\n}\n\n\nimg#coffee-beans {\n  z-index: 3;\n}\n\nimg#splash {\n  z-index: 4;\n}\n\nimg#shadow {\n  z-index: 2;\n}\n\n/*--------------------------------------------------------------\n# Jumbotron\n--------------------------------------------------------------*/\n.jumbotron p {\n  font-size: 1.5em;\n}\n\n.cta {\n  background: linear-gradient(rgba(2, 2, 2, 0.5), rgba(0, 0, 0, 0.5)), url(\"../images/coffee-bg.jpg\") fixed center center;\n  background-size: cover;\n  padding: 60px 0;\n}\n\n.cta h3 {\n  color: #DDF2FF;\n  font-size: 1.5em;\n  font-weight: bold;\n  margin-bottom: 1rem;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.cta p {\n  font-size: 1.1rem;\n  color: #DDF2FF;\n}\n\n/*--------------------------------------------------------------\n# hero\n--------------------------------------------------------------*/\n.hero h1 {\n  margin-top: 1rem;\n  font-size: 7rem;\n}\n\n.hero-dark p {\n  color: #FCEAFF;\n}\n\n.hero-light p {\n  color: #683E00;\n}\n\n.hero h1:after {\n  content: \".\";\n}\n\n.hero-dark h1 {\n  color: #FCEAFF;\n}\n\n.hero-dark h1:after {\n  color: #00C9A9;\n}\n\n.hero-light h1 {\n  color: #683E00;\n}\n\n.hero-light h1:after {\n  color: #897456;\n}\n\n.hero{\n  margin-bottom: 11em;\n}\n\n/*--------------------------------------------------------------\n# Links & Badges\n--------------------------------------------------------------*/\na.a-dark {\n  color: #00C9A9;\n  text-decoration: none;\n}\n\na.a-light {\n  color: #897456;\n  text-decoration: none;\n}\n\na.a-dark:hover {\n  color: #009d83;\n}\n\na.a-light:hover {\n  color: #5b79a2;\n}\n\n.badge.bg-dark {\n  background-color: #897456 !important;\n}\n\n.badge.bg-light {\n  color: #1E1E1E !important;\n}\n\n/*--------------------------------------------------------------\n# About\n--------------------------------------------------------------*/\n.about{\n  background-color: transparent;\n  border-radius: 30px;\n  padding:3%;\n  padding-left:5%;\n  padding-right:5%;\n  margin-bottom:7%;\n  /* box-shadow: 0px 50px 50px -40px #000000; */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);\n  margin-top:2%;\n  transition: 0.3s ease-in-out;\n}\n\n.about:hover{\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3), 0 12px 40px rgba(0, 0, 0, 0.25);\n}\n\n.about.about-dark{\n  border:5px solid #9d9d9d;\n}\n\n.about.about-dark:hover{\n  border:5px solid #00C9A9;\n}\n\n.about.about-light{\n  border:5px solid #DDF2FF;\n}\n\n.about.about-light:hover{\n  border:5px solid #bdb4a8;\n}\n\n.about .about-icon{\n  padding:0.9%;\n  font-size: 1.5rem;\n}\n\n.about .about-icon-dark{\n  background-color:#00C9A9;\n  color:#2D1458;\n}\n\n.about .about-icon-light{\n  background-color:#683E00;\n  color:#DDF2FF;\n}\n\n.about h1{\n  font-size: 6rem;\n}\n\n.about h1:nth-child(1){\n  margin-left:-2rem;\n}\n\n.about h1:nth-child(2){\n  margin-left:-0.7rem;\n}\n\n.about.about-dark h1{\n  color:#2D1458;\n}\n\n.about.about-light h1{\n  color:#683E00;\n}\n\n.about.about-dark h1:nth-child(2):after{\n  content: '.';\n  color:#00C9A9;\n}\n\n.about.about-light h1:nth-child(2):after{\n  content: '.';\n  color:#897456;\n}\n\n.about .about-para{\n  font-size:0.8rem;\n  text-align: end;\n}\n\n.about .about-para-dark{\n  color:#bdbcbc;\n}\n\n.about .about-para-light{\n  color:#747474;\n}\n\n/*--------------------------------------------------------------\n# Contact\n--------------------------------------------------------------*/\n.card.scroll-background {\n  background: #FFFFFF; /* Base color of the scroll */\n  background-image: \n  linear-gradient(135deg, #FFFFFF 0%, #F5F5F5 50%, #FFFFFF 100%),\n  linear-gradient(to right, #FFFFFF 0%, #F5F5F5 50%, #FFFFFF 100%);\n  background-blend-mode: multiply;\n  border-radius: 4px;\n  /* box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1),\n              inset 0 -1px 3px rgba(0, 0, 0, 0.05); */\n  position: relative;\n  overflow: hidden;\n  padding: 2rem; /* Adjust based on how much space you want inside the scroll */\n  height: 100%; /* Adjust based on the size of your scroll */\n  width: 100%; /* Adjust based on the size of your scroll */\n  border:none;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);\n}\n\n.card.scroll-background::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(circle at 20% 20%, rgba(179, 155, 155, 0.1), transparent);\n  pointer-events: none;\n}\n\n.card.scroll-background::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 20px; /* Adjust based on the size of the curl effect */\n  background: radial-gradient(circle at 50% 50%, rgba(86, 85, 85, 0.2), transparent);\n  border-radius: 50% 50% 0 0;\n  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);\n  pointer-events: none;\n}\n\n.card .letter{\n    /* font-family: 'Cedarville Cursive', cursive; */\n    font-family: 'Tangerine', cursive;;\n    font-size:2.2rem;\n    color:#683E00;\n}\n\n.container-fluid.contact-dark label{\n    color:#FCEAFF;\n}\n\n.container-fluid.contact input,.container-fluid.contact textarea{\n    background-color: transparent;\n    border:none;\n    border-radius: 1px;\n}\n\n.container-fluid.contact select{\n    background-color: transparent;\n    border:none;\n    border-radius: 1px;\n}\n\n.container-fluid.contact-dark input,.container-fluid.contact-dark textarea{\n  background-color: transparent;\n    color:#FCEAFF;\n    border-bottom:1px solid #FCEAFF;\n}\n\n.container-fluid.contact-dark select{\n    color:#FCEAFF;\n    border-top:1px solid #FCEAFF;\n}\n\n.container-fluid.contact-dark option{\n    color:#1E1E1E;\n}\n\n.container-fluid.contact-light label{\n    color:#683E00;\n}\n\n.container-fluid.contact-light input,.container-fluid.contact-light textarea{\n    color:#683E00;\n    border-bottom:1px solid #683E00;\n}\n\n.container-fluid.contact-light select{\n    color:#683E00;\n    border-top:1px solid #683E00;\n}\n\n.container-fluid.contact-light option{\n    color:#683E00;\n}\n\n.container-fluid.contact .card{\n    padding-top:1rem;\n    margin-right:3rem;\n    position:relative;\n    top:-10%;\n    height: 120%;\n}\n\n.contact .card-subtitle{\n    font-size: 1.8rem;\n    float:right;\n}\n\n/*--------------------------------------------------------------\n# Menu \n--------------------------------------------------------------*/\n\n.container.menu-list select{\n  background-color: transparent;\n  border:none;\n  border-radius: 1px;\n}\n\n/* .container.menu-list-dark select{\n  color:#FCEAFF;\n  border-top:1px solid #FCEAFF;\n} */\n\n/* .container.menu-list-light select{\n  color:#683E00;\n  border-top:1px solid #683E00;\n} */\n\n.container.menu-list input{\n  background-color: transparent;\n  border:none;\n  border-radius: 1px;\n}\n\n.container.menu-list-dark input,.container.menu-list-dark textarea{\nbackground-color: transparent;\n  color:#FCEAFF;\n  border-bottom:1px solid #FCEAFF;\n}\n\n.container.menu-list-light input,.container.menu-list-light textarea{\n  color:#683E00;\n  border-bottom:1px solid #683E00;\n}\n\n.item-card.card{\n  border: none;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);\n}\n\n.item-card-light.card{\n  background-color: #DDF2FF;\n}\n\n.item-card-dark.card{\n  background-color:#2c2c2c;\n}\n\n.item-card .card-img-container {\n  position: relative;\n}\n\n.item-card .card-price {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background-color: rgba(0, 0, 0, 0.6);\n  padding: 5px 10px;\n  border-radius: 5px;\n  z-index: 2;\n}\n\n.item-card-light .card-price{\n  color: #DDF2FF;\n}\n\n.item-card-dark .card-price{\n  color:#00C9A9;\n}\n\n.item-card .card-img-top {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.item-card .card-body {\n  position: relative;\n  z-index: 1;\n}\n\n.item-card .card-text {\n  height: 4.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  overflow-wrap: break-word;\n}\n\n.item-card small{\n  text-decoration: line-through;\n  color: gray;\n}\n\nsmall.marked-price{\n  text-decoration: line-through;\n  color: gray;\n}\n\n.item-img{\n  border-radius: 5px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);\n}\n\n/*--------------------------------------------------------------\n# Footer\n--------------------------------------------------------------*/\n.footer{\n  font-size:6vh;\n  font-family: 'Montserrat', sans-serif;\n  position:absolute;\n  white-space: nowrap;\n  z-index: 2;\n  padding-top: 4%;\n  padding-bottom: 4%;\n}\n\n.container-fluid.footer-dark {\n  /* background-image: linear-gradient(#6F4F28, #1E1E1E); */\n  color: #1E1E1E;\n}\n\n.container-fluid.footer-light {\n  /* background-image: linear-gradient(#A4C5F8,#6D8FBF); */\n  color: #F9F9F9;\n}\n\n.footer .row.padding-top{\n  padding-top:7rem;\n}\n\n.footer .row.padding-bottom{\n  padding-bottom:20rem;\n}\n\n.footer small{\n  font-size:10px;\n  color:rgb(170, 169, 169);\n  margin-bottom: 10px;\n}\n\n.footer-light small{\n  color:#e7e7e7;\n}\n\n.footer a{\n  font-size:1.5rem;\n}\n\n.footer-light a:hover{\n  border-color:#683E00;\n}\n\n.footer-dark a:hover{\n  border-color:#00C9A9;\n}\n\n.footer-light h1{\n  color:#683E00;\n}\n\n.footer-dark h1:after{\n  content:\".\";\n  color:#00C9A9;\n}\n\n.footer-light h1:after{\n  content:\".\";\n  color:#897456;\n}\n\n/*--------------------------------------------------------------\n# Animated Button\n--------------------------------------------------------------*/\n\n.flow-chart-light h1{\n  color:#683E00;\n}\n\n.flow-chart-dark h1:after{\n  content:\"?\";\n  color:#00C9A9;\n}\n\n.flow-chart-light h1:after{\n  content:\"?\";\n  color:#897456;\n}\n\n\n/*--------------------------------------------------------------\n# Animated Button\n--------------------------------------------------------------*/\na.anime-button.btn-light{\n  color:#634d1a;\n  background-color: #DDF2FF;\n}\n\na.anime-button.btn-light:hover{\n  background-color: #b3dffb;\n}\n\na.anime-button.btn-dark{\n  background-color:#00C9A9;\n  color: #2f145e;\n}\n\na.anime-button.btn-dark:hover {\n  background-color: #00977e;\n  color:#e7e7e7;\n}\n\na.anime-button{\n  position: absolute;\n  padding:1em;\n  letter-spacing:2px;\n  text-transform:uppercase;\n  text-decoration:none;\n  box-shadow:0 5px 10px rgba(0,0,0,.5);\n  overflow:hidden;\n  border:none;\n}\n\na.anime-button:before{\ncontent: '';\nposition: absolute;\ntop: 2px;\nleft: 2px;\nbottom: 2px;\nwidth: 50%;\nbackground: rgba(255,255,255,0.05);\n}\n\na.anime-button-light span:nth-child(1){\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(to right, #d2b48c, #c8a475, #b89463, #a5834e, #8f7138, #7a6025, #634d1a);\n  animation: animate1 2s linear infinite;\n}\n\na.anime-button-dark span:nth-child(1){\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;  \n  background: linear-gradient(to left, #00C9A9, #00B0A4, #009f95, #008f86, #007d78, #006d6a, #005d5b);\n  animation: animate1 2s linear infinite;\n}\n\n@keyframes animate1{\n   0%\n   {\n     transform:translateX(-100%);\n   \n   }\n   100%\n   {\n     transform:translateX(100%);\n   \n   }\n}\n\n/* a.anime-button-light span:nth-child(2){\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(to bottom, #00FFFF, #00D4FF, #00AAFF, #0088FF, #0066FF, #004CFF, #002EFF);\n  animation: animate2 2s linear infinite;\n  animation-delay: 1s;\n}\n\n@keyframes animate2 {\n   0%\n   {\n     transform:translateY(-100%);\n   \n   }\n   100%\n   {\n     transform:translateY(100%);\n   \n   }\n} */\n\na.anime-button-light span:nth-child(3){\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(to left, #d2b48c, #c8a475, #b89463, #a5834e, #8f7138, #7a6025, #634d1a);\n  animation: animate3 2s linear infinite;\n}\n\na.anime-button-dark span:nth-child(3){\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(to left, #00C9A9, #00B0A4, #009f95, #008f86, #007d78, #006d6a, #005d5b);\n  animation: animate3 2s linear infinite;\n}\n\n@keyframes animate3\n  {\n   0%\n   {\n     transform:translateX(100%);\n   \n   }\n   100%\n   {\n     transform:translateX(-100%);\n   \n   }\n}\n\n/* a.anime-button-light span:nth-child(4){\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(to top, #00FFFF, #00D4FF, #00AAFF, #0088FF, #0066FF, #004CFF, #002EFF);\n  animation: animate4 2s linear infinite;\n  animation-delay: 1s;\n}\n\n@keyframes animate4 {\n   0%\n   {\n     transform:translateY(100%);\n   \n   }\n   100%\n   {\n     transform:translateY(-100%);\n   \n   }\n} */\n\n\n/*--------------------------------------------------------------\n# Customer Details\n--------------------------------------------------------------*/\n\n.customer{\n  font-size: 6em;\n}\n\n.bronze-customer {\n  background: linear-gradient(to right, #F2C185, #8C6046, #BF8F65, #D9A577,  #593528);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.silver-customer {\n  background: linear-gradient(to right, #DCEAF2, #3B403F, #C5D1D9 , #79878C,  #0C0D0C);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.gold-customer {\n  background: linear-gradient(to right, #F2CF66, #A65814, #F2BF5E, #D99036, #59331D);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.platinum-customer {\n  background: linear-gradient(to right, #727A8C, #434D59, #C7CFD9, #366873, #143B40);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.bizarre-coin-light {\n  margin-top:0.2em;\n  font-size: 12rem;\n  filter: drop-shadow(5px 1px 4px rgba(0, 0, 0, 0.9));\n  color:#A65814;\n}\n\n.bizarre-coin-dark {\n  margin-top:0.2em;\n  font-size: 12rem;\n  filter: drop-shadow(5px 1px 4px rgba(0, 0, 0, 0.9));\n  color:#F2BF5E;\n}\n\n.coin-currency{\n  position: relative;\n  top: -2px;\n}\n\n.fa-bitcoin {\n  background: linear-gradient(to right, #F2CF66, #A65814, #F2BF5E, #D99036);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-fill-color: transparent;\n  margin-top:0.2em;\n  font-size: 12rem;\n  filter: drop-shadow(5px 1px 4px rgba(44, 44, 44, 0.9));\n}\n\n.verified-icon{\n  font-size: 3rem;\n  position: relative;\n  top: -1em;\n  left: -0.2em;\n}\n\n.verified-icon-light{\n  color:#A65814;\n}\n\n.verified-icon-dark{\n  color:#00C9A9;\n}\n\n/*--------------------------------------------------------------\n# Not Found\n--------------------------------------------------------------*/\n.not-found{\n  padding: 1.7em;\n  font-size: 6em;\n}\n\n.not-found-light {\n  background: linear-gradient(to right, #F2C185, #8C6046, #BF8F65, #D9A577,  #593528);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: bold;\n  display: inline-block;\n}\n\n.not-found-dark {\n  background: linear-gradient(to right, #00C9A9, #007d78, #00B0A4, #008f86, #005d5b);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: bold;\n  display: inline-block;\n}\n\n\n/*--------------------------------------------------------------\n# Media Queries Small Phones\n--------------------------------------------------------------*/\n\n@media only screen and (max-width: 600px) {\n\n  .btn{\n    font-size: 1em;\n  }\n  \n  .section-break-title {\n    padding-bottom: 2%;\n    margin-left: 5%;\n    padding-top:2%;\n  }\n\n  .jumbotron p{\n    font-size: 1.2em;\n  }\n\n  .cta h3 {\n    font-size: 1em;\n  }\n  \n  .cta p {\n    font-size: 0.7rem;\n  }\n\n  .hero h1{\n    margin-top:2%;\n    font-size: 4.5rem;\n  }\n\n  .hero p {\n    margin-top:2rem;\n    font-size: 1.2rem;\n  }\n\n  .customer{\n    font-size: 3em;\n  }\n\n  .not-found{\n    padding: 1.2em;\n    font-size: 3em;\n    text-align: center;\n  }\n\n  .hero .float-end{\n    float:none!important;\n  }\n\n  .footer .row.padding-top{\n    padding-top:14rem;\n  }\n  \n  .footer .row.padding-bottom{\n    padding-bottom:21rem;\n  }\n\n  .card .letter{\n    font-size:1.5rem;\n  }\n\n  .contact .card-subtitle{\n    font-size: 1.2rem;\n  }\n\n  .about{\n    padding:2rem;\n    margin-bottom: 5rem;\n  }\n\n  .about h1{\n  font-size: 4rem;\n  }\n\n  .about .about-para{\n    font-size:0.6rem;\n    text-align: center;\n  }\n\n  a.a-dark{\n    font-size:0.6rem\n  }\n\n  a.a-light{\n    font-size:0.7rem\n  }\n\n  .swiper-slide{\n    left: -6rem;\n  }\n  \n  .verified-icon{\n    font-size: 1.8rem;\n    position: relative;\n    top: -0.7em;\n    left: -0.2em;\n  }\n}\n\n/*--------------------------------------------------------------\n# Media Queries iPhone\n--------------------------------------------------------------*/\n@media (min-width: 400px) and (max-width: 600px) {\n\n  .menu-container{\n    margin-left:20px;\n  }\n\n  .hero{\n    margin-bottom: 16em;\n  }\n\n}\n\n\n/*--------------------------------------------------------------\n# Media Queries Landscape Tablets\n--------------------------------------------------------------*/\n@media only screen and (min-width: 768px) {\n\n  .hero h1{\n    margin-top:5%;\n    font-size: 4rem;\n  }\n\n  .customer{\n    font-size: 4em;\n  }\n\n  .not-found{\n    padding: 0.9em;\n    font-size: 4em;\n  }\n\n  .footer .row.padding-top{\n    padding-top:10rem;\n  }\n  \n  .footer .row.padding-bottom{\n    padding-bottom:21rem;\n  }\n\n  .card .letter{\n    font-size:1.8rem;\n  }\n\n  .contact .card-subtitle{\n    font-size: 1.5rem;\n  }\n}\n\n/*--------------------------------------------------------------\n# Media Queries Landscape Tablets\n--------------------------------------------------------------*/\n@media only screen and (min-width: 992px) {\n\n  .hero h1{\n    margin-top:0%;\n    font-size: 6.6rem;\n  }  \n\n  .customer{\n    font-size: 5em;\n  }\n\n  .not-found{\n    padding: 1em;\n    font-size: 6em;\n  }\n\n  .footer .row.padding-top{\n    padding-top:8.8rem;\n  }\n  \n  .footer .row.padding-bottom{\n    padding-bottom:20rem;\n  }\n\n  .card .letter{\n    font-size:2.1rem;\n  }\n\n  .contact .card-subtitle{\n    font-size: 1.8rem;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
